import * as Immutable from 'immutable';

export interface IProductVariantStore {
	id: number
	id_type: number
	slug: string
	name: string
	theorder: number
}

const defaultProductVariantStore = Immutable.Record<IProductVariantStore>({
	id: 0,
	id_type: 0,
	slug: "",
	name: "",
	theorder: 0,
});

export default class ProductVariantStore extends defaultProductVariantStore implements IProductVariantStore { }